import { createSlice } from '@reduxjs/toolkit';
import { getCalendarEvents } from '../../utils/FamilyApiService';
import moment from 'moment';

export const calendarSlice = createSlice({
  name: 'calendar',
  initialState: {
    isLoading: false,
    events: [],
  },
  reducers: {
    receivedEvents: (state, action) => {
      state.events = action.payload.map((object) => ({
        title: object.subject,
        start: object.isAllDay ? new Date(moment(object.start).year(), moment(object.start).month(), moment(object.start).local().date()) : moment(object.start).local().toDate(),
        end: object.isAllDay ? new Date(moment(object.end).year(), moment(object.end).month(), moment(object.end).local().date()) : moment(object.end).local().toDate(),
        allDay: object.isAllDay,
        resource: object.calendarName

      }));
    },
    test: (state, action) => {
      // console.log(action);
      // dispatchEvent.receivedEvents();
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;   
    }
  },
});

export const { receivedEvents, test, setLoading } = calendarSlice.actions;

export default calendarSlice.reducer;



export function GetCalendarEvents() {
  return async (dispatch) => {
    try {
      dispatch(setLoading(true));
      var events = await getCalendarEvents();
      dispatch(receivedEvents(events));
      dispatch(setLoading(false));
    }
    catch (e) {
      console.log(e);
    }
  }
};
